import gql from "graphql-tag";


export const getTopics = gql`
    query topics @api(name: "textkit") {
        topics: touchless_topic {
            id: uuid
            name: context_text
            description: context_text
            messageTemplates: templates {
                id: label
                topicId: parent_uuid
                locale
                template: context_text
                placeholders : context_json
            }
            contactCount: context_int
        }
    }
`;

export const getAllTopics = gql`
    query FindAllTopics  @api(name: "touchless")  {
       topics: touchless_topic {
            topic_id: uuid
            description: context_text
            name: context_text
            state
        }
    }
`;


export const findCustomer = gql`
     query FindCustomer @api(name: "touchless")  {
        findCustomer: touchless_config {    
            customerId:uuid
            config
        }
    }
`;

export const findAllWidgets = gql`
    query FindAllWidgets @api(name: "touchless") {
        widget:touchless_widget {
            name
            url
            scope
            type
            domains
            path
            isEnabled:is_enabled
        }
    }
`;

export const getParticipationsForConversation = gql`
    query participationForConversation ($conversationId: uuid) @api(name: "touchless") {
        conversation: touchless_conversation (where: { uuid: {_eq: $conversationId } }) {
            participants {
                participantId: uuid
            }
            topics {
                id: parent_uuid
            }
        }
    }
`;


export const GetAllConversation = gql`
    query getConversations @api(name: "touchless") {
        all: touchless_account {
            services: conversation_services {
                conversations(where: {state: {_neq: ARCHIVED}}) {
                    id: uuid
                    primaryRepresentativeId: actor_uuid
                    category: state
                    hydration
                    metadata: context_json
                    createdAt: created_at
                    messages {
                        id: uuid
                        created_at
                        body: secret_value
                        media: context_text
                    }
                    topics {
                        id: parent_uuid
                        speaker_id: actor_uuid
                    }
                    representatives: participants(where: {channel: {_is_null: true}}) {
                        id: actor_uuid
                        contact {
                            lastName: family_name
                            firstName: given_name
                        }
                    }
                    contacts: participants(where: {channel: {_is_null: false}}) {
                        id: uuid
                        contactId: linked_uuid
                        externalId: external_id
                        representative_id: actor_uuid
                        inboundAddress: inbound_address
                        outboundAddress: outbound_address
                        metadata: context_json
                        locale
                        channel
                        opt_out {
                            added_at
                            channel_type
                            source
                        }
                        topics {
                            id: parent_uuid
                        }
                        contact {
                            lastName: family_name
                            firstName: given_name
                            locator
                            middleName: middle_name
                            parent_account_uuid
                            parent_config_id
                            parent_service_uuid
                            po_box
                            preferred_name
                            rural_route
                            street_direction
                            street_name
                            street_num
                            street_suffix
                            unit_num
                            unit_type
                        }
                    }
                }
            }
        }
    }
`;

export const VERIFY_MESSAGE = gql`
    query VerifyMessage($VerifyMessageInput: VerifyMessageInput!) @api(name: "textkit") {
        verifyMessage(input: $VerifyMessageInput) {
            originalContent
            content
            complianceAdvices {
                complianceRule
                adviceAction
                reasonCode
                reasonMessage
                reasonDescription
                content
                contentArea {
                    start
                    end
                }
            }
        }
    }
`;


export const findAllRepresentatives = gql`
    query GetAllRepresentatives @api(name: "touchless") {
        representatives: touchless_representative {
            participantId: uuid
            identifier
        }
    }
`;

export const findRepresentativeSettings = gql`
    query RepresentativeSetting($identifier: String) @api(name: "touchless") {
        representative: touchless_representative(where: {identifier: {_eq: $identifier}}) {
            identifier
            locale
            participantId: uuid
            incomingEnabled: is_accepting_incoming
        }
    }
`;

export const findAllIncoming = gql`
    query findAllIncoming @api(name: "touchless") {
        incoming: touchless_phone_number{
            incomingId: uuid
            outboundNumber: outbound_address
            name: label
            defaultRepresentative: actor_uuid
        }
    }
`;